// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Cargas por estatus en el dashboard (20-oct-2026; rediseño de esa misma tarde). Ver LoadsByStatusCard.tsx.
 *
 * 📌 \`--status\` y \`--delay\` los pone cada elemento en línea; no son tokens del tema.
 */

.LoadsByStatusCard_card__vsyEn {
  position: relative;
  overflow: hidden;
}
/* El mismo brillo de esquina que Recent loads, para que se lean como un par. */
.LoadsByStatusCard_card__vsyEn::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(
    140% 80% at 100% 0%,
    color-mix(in srgb, var(--dylo-orange) 10%, transparent) 0%,
    transparent 55%
  );
  pointer-events: none;
}
.LoadsByStatusCard_card__vsyEn > * {
  position: relative;
}

.LoadsByStatusCard_summary__7exII {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin: -4px 0 14px;
}

.LoadsByStatusCard_total__NQsAG {
  font-size: 34px;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.02em;
  color: var(--dylo-ink);
  font-variant-numeric: tabular-nums;
}

.LoadsByStatusCard_totalLabel__i-CdP {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 13px;
  color: var(--dylo-muted);
}

.LoadsByStatusCard_chip__qyc7g {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 9px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;
  color: var(--dylo-ink);
  background: color-mix(in srgb, #2f9fd0 16%, transparent);
}
.LoadsByStatusCard_chip__qyc7g::before {
  content: '';
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #2f9fd0;
  box-shadow: 0 0 0 3px color-mix(in srgb, #2f9fd0 25%, transparent);
}

/* La barra partida: un tramo por estatus, proporcional, con un mínimo para que ninguno desaparezca. */
.LoadsByStatusCard_stack__FhlS2 {
  display: flex;
  gap: 3px;
  height: 10px;
  margin-bottom: 16px;
}
.LoadsByStatusCard_segment__sS\\+ki {
  flex-basis: 0;
  min-width: 6px;
  border-radius: 999px;
  background: var(--status);
  transform-origin: left center;
  animation: LoadsByStatusCard_lbs-grow__o2dX- 0.7s cubic-bezier(0.2, 0.7, 0.2, 1) both;
  animation-delay: var(--delay);
}

.LoadsByStatusCard_list__z0Ync {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.LoadsByStatusCard_item__PI9Lk {
  display: grid;
  grid-template-columns: 10px minmax(0, 1fr) auto 42px;
  align-items: center;
  gap: 10px;
  padding: 7px 8px;
  border-radius: 10px;
  font-size: 13px;
  color: var(--dylo-ink);
  transition: background-color 0.15s ease;
}
.LoadsByStatusCard_item__PI9Lk:hover {
  background: color-mix(in srgb, var(--status) 9%, transparent);
}

.LoadsByStatusCard_dot__punot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--status);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--status) 22%, transparent);
}

.LoadsByStatusCard_label__AM4Em {
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.LoadsByStatusCard_count__9H2bh {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.LoadsByStatusCard_pct__SEIGu {
  text-align: right;
  font-size: 12px;
  color: var(--dylo-muted);
  font-variant-numeric: tabular-nums;
}

.LoadsByStatusCard_empty__e7Oe8 {
  margin: 4px 0;
  font-size: 13px;
  color: var(--dylo-muted);
}

@keyframes LoadsByStatusCard_lbs-grow__o2dX- {
  from {
    transform: scaleX(0);
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .LoadsByStatusCard_segment__sS\\+ki {
    animation: none;
  }
  .LoadsByStatusCard_item__PI9Lk {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Dashboard/components/LoadsByStatusCard.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA,+EAA+E;AAC/E;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;GAIC;EACD,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,wDAAwD;AAC1D;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA,sGAAsG;AACtG;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,6BAA6B;EAC7B,qFAA4D;EAC5D,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,uCAAuC;AACzC;AACA;EACE,6DAA6D;AAC/D;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,wEAAwE;AAC1E;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE;IACE,oBAAoB;IACpB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["/*\n * Cargas por estatus en el dashboard (20-oct-2026; rediseño de esa misma tarde). Ver LoadsByStatusCard.tsx.\n *\n * 📌 `--status` y `--delay` los pone cada elemento en línea; no son tokens del tema.\n */\n\n.card {\n  position: relative;\n  overflow: hidden;\n}\n/* El mismo brillo de esquina que Recent loads, para que se lean como un par. */\n.card::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(\n    140% 80% at 100% 0%,\n    color-mix(in srgb, var(--dylo-orange) 10%, transparent) 0%,\n    transparent 55%\n  );\n  pointer-events: none;\n}\n.card > * {\n  position: relative;\n}\n\n.summary {\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  margin: -4px 0 14px;\n}\n\n.total {\n  font-size: 34px;\n  font-weight: 700;\n  line-height: 1;\n  letter-spacing: -0.02em;\n  color: var(--dylo-ink);\n  font-variant-numeric: tabular-nums;\n}\n\n.totalLabel {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  font-size: 13px;\n  color: var(--dylo-muted);\n}\n\n.chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 2px 9px;\n  border-radius: 999px;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--dylo-ink);\n  background: color-mix(in srgb, #2f9fd0 16%, transparent);\n}\n.chip::before {\n  content: '';\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #2f9fd0;\n  box-shadow: 0 0 0 3px color-mix(in srgb, #2f9fd0 25%, transparent);\n}\n\n/* La barra partida: un tramo por estatus, proporcional, con un mínimo para que ninguno desaparezca. */\n.stack {\n  display: flex;\n  gap: 3px;\n  height: 10px;\n  margin-bottom: 16px;\n}\n.segment {\n  flex-basis: 0;\n  min-width: 6px;\n  border-radius: 999px;\n  background: var(--status);\n  transform-origin: left center;\n  animation: lbs-grow 0.7s cubic-bezier(0.2, 0.7, 0.2, 1) both;\n  animation-delay: var(--delay);\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.item {\n  display: grid;\n  grid-template-columns: 10px minmax(0, 1fr) auto 42px;\n  align-items: center;\n  gap: 10px;\n  padding: 7px 8px;\n  border-radius: 10px;\n  font-size: 13px;\n  color: var(--dylo-ink);\n  transition: background-color 0.15s ease;\n}\n.item:hover {\n  background: color-mix(in srgb, var(--status) 9%, transparent);\n}\n\n.dot {\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--status);\n  box-shadow: 0 0 0 3px color-mix(in srgb, var(--status) 22%, transparent);\n}\n\n.label {\n  min-width: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.count {\n  font-weight: 700;\n  font-variant-numeric: tabular-nums;\n}\n\n.pct {\n  text-align: right;\n  font-size: 12px;\n  color: var(--dylo-muted);\n  font-variant-numeric: tabular-nums;\n}\n\n.empty {\n  margin: 4px 0;\n  font-size: 13px;\n  color: var(--dylo-muted);\n}\n\n@keyframes lbs-grow {\n  from {\n    transform: scaleX(0);\n    opacity: 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .segment {\n    animation: none;\n  }\n  .item {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `LoadsByStatusCard_card__vsyEn`,
	"summary": `LoadsByStatusCard_summary__7exII`,
	"total": `LoadsByStatusCard_total__NQsAG`,
	"totalLabel": `LoadsByStatusCard_totalLabel__i-CdP`,
	"chip": `LoadsByStatusCard_chip__qyc7g`,
	"stack": `LoadsByStatusCard_stack__FhlS2`,
	"segment": `LoadsByStatusCard_segment__sS+ki`,
	"lbs-grow": `LoadsByStatusCard_lbs-grow__o2dX-`,
	"list": `LoadsByStatusCard_list__z0Ync`,
	"item": `LoadsByStatusCard_item__PI9Lk`,
	"dot": `LoadsByStatusCard_dot__punot`,
	"label": `LoadsByStatusCard_label__AM4Em`,
	"count": `LoadsByStatusCard_count__9H2bh`,
	"pct": `LoadsByStatusCard_pct__SEIGu`,
	"empty": `LoadsByStatusCard_empty__e7Oe8`
};
export default ___CSS_LOADER_EXPORT___;
